import { Loader } from './Loader'

interface ButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  width?: 'full' | 'auto'
  isSubmitting?: boolean
}

export const Button = ({
  children,
  width = 'full',
  isSubmitting = false,
  ...buttonProps
}: ButtonProps): JSX.Element => (
  <button
    className={`relative mt-3 self-start w-full ${
      width === 'full' ? 'md:w-full' : 'md:w-auto'
    } rounded-full bg-brand-purple py-4 px-16 text-white font-normal hover-hover:hover:opacity-80 active:opacity-80 border border-transparent focus:outline-none focus:ring-2 disabled:bg-gray-300`}
    disabled={isSubmitting}
    {...buttonProps}
  >
    {isSubmitting && <Loader />}
    {children}
  </button>
)
